import React, { useState } from "react";
import "./Tracking.css";
import { FaTruck } from "react-icons/fa";

const statusSteps = ["CREATED", "COLLECTED", "DEPARTED","IN TRANSIT","ARRIVED AT DESTINATION","OUT FOR DELIVERY","DELIVERED"];

function Tracking() {
  const [awbId, setAwbId] = useState("");
  const [awbData, setAwbData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchTracking = async () => {

    if (!awbId) return;

    setLoading(true);
    setError("");
    setAwbData(null);

    try {

      const response = await fetch(
        `http://localhost:8080/api/airWayBill/get/${awbId}`
      );

      const result = await response.json();

      if (!response.ok || !result.datum) {
        setError("Tracking ID not found");
        return;
      }

      setAwbData(result.datum);

    } catch (err) {

      setError("Server not reachable");

    } finally {

      setLoading(false);

    }
  };

  // Find latest status using currentStatus flag
  const latestStatus = awbData?.trackingHistory?.find(
    (h) => h.currentStatus === true
  )?.trackingStatus;

  const activeStep = statusSteps.indexOf(latestStatus);

  const progress = activeStep <= 0
  ? 0
  : (activeStep / 
    (statusSteps.length-1)
  )*100;

  return (
    <section className="tracking-section py-5">

      <div className="container text-center">

        <h2 className="fw-bold tracking-title mb-3">
          Track Your Shipment
        </h2>

      {/* Input */}
        <div className="tracking-form mx-auto p-4 shadow rounded bg-white mt-5">

<input
  type="text"
  placeholder="Enter AWB Number"
  className="form-control mb-3 text-center"
  value={awbId}
  onChange={(e) => setAwbId(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") fetchTracking();
  }}
/>

          <button
            className="btn btn-success px-4"
            onClick={fetchTracking}
            disabled={loading}
          >
            {loading ? "Tracking..." : "Track Now"}
          </button>

          {error && <p className="text-danger mt-3">{error}</p>}

        </div>
        
        {awbData && (
          <>
            {/* Shipment Card */}
            <div className="card mt-4 shadow tracking-details">

              <div className="card-body">

                <h5 className="fw-bold mb-3 text-success">
                  Shipment Details
                </h5>

                <div className="row text-start">

                  <div className="col-md-6">

                    <p><strong>AWB ID:</strong> {awbData.awbId}</p>
                    <p><strong>Product:</strong> {awbData.product}</p>
                    <p><strong>Vendor:</strong> {awbData.vendor}</p>

                  </div>

                  <div className="col-md-6">

                    <p>
                      <strong>Shipper:</strong>{" "}
                      {awbData.shipper?.companyName}
                    </p>

                    <p>
                      <strong>Consignee:</strong>{" "}
                      {awbData.consignee?.companyName}
                    </p>

                    <p>
                      <strong>From:</strong>{" "}
                      {awbData.shipper?.city}
                    </p>

                    <p>
                      <strong>To:</strong>{" "}
                      {awbData.consignee?.city}
                    </p>

                  </div>

                </div>

              </div>

            </div>

            {/* Horizontal Progress */}
            <div className="tracking-bar-wrapper mt-4">

              <div className="tracking-bar">

                <div className="tracking-line" style={{"--progress": '${(progress}%'}}></div>
              
              
                {statusSteps.map((status, index) => (

                  <div
                    key={status}
                    className={`tracking-step ${
                      index <= activeStep ? "active" : ""
                    }`}
                  >

                    <div className="tracking-dot"></div>

                    <span>{status}</span>

                  </div>

                ))}

             <div
  className="truck-wrapper"
  style={{
    left: `${progress}%)`,
    transform: "translateX(-50%)",
  }}
>
                  <FaTruck className="truck-icon" />
                </div>

              </div>

            </div>

            {/* Vertical Premium Timeline */}
            {awbData?.trackingHistory?.length > 0 && (

              <div className="card mt-5 shadow tracking-history">

                <div className="card-body">

                  <h5 className="fw-bold mb-4 text-center text-success">
                    Tracking Timeline
                  </h5>

                  <div className="timeline">

                    {awbData.trackingHistory
  .map((history, index) =>  
                        {

                        const isLatest = history.currentStatus;

                        return (

                          <div
                            key={history.id}
                            className={`timeline-item ${
                              isLatest ? "latest" : ""
                            }`}
                          >

                            <div className="timeline-dot"></div>

                            <div className="timeline-content">

                              {isLatest && (
                                <span className="live-badge">
                                  ● LIVE
                                </span>
                              )}

                              <h6 className="mb-1 fw-bold">
                                {history.trackingStatus}
                              </h6>

                              <small className="text-muted">
                                {history.date} {history.time}
                              </small>

                              <div className="mt-1 small text-secondary">
                                Location: {history.location}
                              </div>

                              <div className="mt-1 small text-secondary">
                                Updated By: {history.updatedBy}
                              </div>

                              {history.comments && (
                                <div className="mt-1 small text-secondary">
                                  {history.comments}
                                </div>
                              )}

                            </div>

                          </div>

                        );

                      })}

                  </div>

                </div>

              </div>

            )}

          </>
        )}

  

      </div>

    </section>
  );
}

export default Tracking;